<template lang='pug'>
div
    div.fullwidth(v-if="$route.params.lang == 'en'")
        div.title-container
            h1.product-title PD Reference Signal Generators
            //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.

        router-link.section(to="/en/products/cal-uhf")
            .column-container
                .column
                    .producttitle CAL-UHF
                    .subtitle Calibrator for UHF PD Measurement
                    ul
                        li Reference signal for the calibration of UHF PD measurement devices
                        li Output range -70 dBm … 0 dBm at 50 Ω
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-UHF-S.png', alt='CAL-UHF', title='CAL-UHF')

        router-link.section(to="/en/products/cal-iec")
            .column-container
                .column
                    .producttitle CAL-IEC
                    .subtitle Calibrator for Electrical PD Measurement
                    ul
                        li Reference signal for the calibration of electrical PD measurement systems
                        li IEC 60270 conform
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-IEC-S.png', alt='CAL-IEC', title='CAL-IEC')

        router-link.section(to="/en/products/hfig-600")
            .column-container
                .column
                    .producttitle HFIG-600
                    .subtitle  Broadband VHF/UHF Pulse Generator
                    ul
                        li High bandwidth 1&nbsp;GHz (-1&nbsp;dB) / 1.7&nbsp;GHz (-3&nbsp;dB)
                        li Short rise time 80&nbsp;ps
                
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/HFIG-600.webp')
                        img( src='@/assets/photos/product_shots/HFIG-600.png', width="100%", alt='HFIG-600', title='HFIG-600')

    div.fullwidth(v-if="$route.params.lang == 'de'")
        div.title-container
            h1.product-title TE-Referenzsignal&shy;generatoren
            //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.

        router-link.section(to="/de/products/cal-uhf")
            .column-container
                .column
                    .producttitle CAL-UHF
                    .subtitle Kalibrator für UHF-TE-Messung
                    ul
                        li Referenzsignal für die Kalibrierung von UHF-TE-Messgeräten
                        li Ausgangspegel -70 dBm ... 0 dBm an 50 Ω
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-UHF-S.png', alt='CAL-UHF', title='CAL-UHF')

        router-link.section(to="/de/products/cal-iec")
            .column-container
                .column
                    .producttitle CAL-IEC
                    .subtitle Kalibrator für elektrische TE-Messung
                    ul
                        li Referenzsignal für die Kalibrierung von elektrischen TE-Messsystemen
                        li Konform zu IEC 60270
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-IEC-S.png', alt='CAL-IEC', title='CAL-IEC')

        router-link.section(to="/de/products/hfig-600")
            .column-container
                .column
                    .producttitle HFIG-600
                    .subtitle Breitband VHF/UHF Impulsgenerator
                    ul
                        li Hohe Bandbreite: 1 GHz (-1 dB) / 1,7 GHz (-3 dB)
                        li Kurze Anstiegszeit 80 ps
                
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/HFIG-600.webp')
                        img( src='@/assets/photos/product_shots/HFIG-600.png', width="100%", alt='HFIG-600', title='HFIG-600')
    
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | TE-Referenzsignalgeneratoren",
            description:
                "Referenzsignalgeneratoren und TE-Kalibratoren",
        },
        en: {
            title: "BSS | PD Reference Signal Generators",
            description:
                "Reference Signal Generators and PD Calibrators",
        },
    },
};
</script>

<style lang='sass' scoped>
@import '@/assets/sass/product_overview.sass'
</style>